import { styled } from '@mui/system';
import { Typography } from '@mui/material';
import Switch from '@mui/material/Switch';

interface RootDivProps {
  hidden: boolean;
  childAmount: number;
}

const RootDiv = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hidden' && prop !== 'childAmount',
})<RootDivProps>(({ hidden, childAmount, theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    border: '1px solid #EAEAEA',
    borderRadius: '10px',
    height: hidden ? '0px' : `calc(84px + ${childAmount} * 64px)`,
    padding: hidden ? '0px 15px 0px 15px' : '15px 15px 8px 15px',
    opacity: hidden ? 0 : 1,
    marginTop: hidden ? '0px' : '15px',
    transition: 'all 0.3s ease-in',
    '& > *': {
      opacity: hidden ? 0 : 1,
      transition: 'all 0.3s ease-in',
    },
    [theme.breakpoints.down(375)]: {
      height: hidden ? '0px' : `calc(63px + ${childAmount} * 84px)`,
    },
    [theme.breakpoints.down(258)]: {
      height: hidden ? '0px' : `calc(87px + ${childAmount} * 84px)`,
    },
  };
});

const InsuranceItem = styled('div')({
  display: 'flex',
  padding: '10px 0px',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
});

const InsuranceSubItem = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'left',
  gap: '10px',
});

const TitleTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '24px',
  letterSpacing: '0.16px',
  textAlign: 'left',
});

const CheckIconContainer = styled('div')({
  position: 'relative',
  width: '24px',
  height: '24px',
  marginTop: '10px',
});

const InformationTypography = styled(Typography)({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '21px',
  letterSpacing: '0.16px',
  textAlign: 'left',
  color: '#757475',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  transition: 'color 0.3s ease-in-out',
});

const TextContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  [theme.breakpoints.down(400)]: {
    maxWidth: '50vw',
  },
  [theme.breakpoints.down(300)]: {
    maxWidth: '40vw',
  },
}));

const SwitchButton = styled(Switch)({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#0A7ABE',
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#AFD5FF',
  },
});

const AddInsurance = styled(Typography)({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '21px',
  letterSpacing: '0.16px',
  color: '#0A7ABE',
  cursor: 'pointer',
});

const AddInsuranceContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '1px',
  justifyContent: 'flex-start',
  marginTop: '10px',
  marginBottom: '5px',
  cursor: 'pointer',
});

const IconContainer = styled('div')({
  display: 'flex',
  cursor: 'pointer',
});

const LoaderContainer = styled('div')({
  display: 'flex',
  marginRight: 18,
});

const InsuranceSkeletonContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  marginTop: '15px',
});

const AddInsuranceTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '100%',
  letterSpacing: '0.16px',
  color: '#0A7ABE',
});

export {
  RootDiv,
  InsuranceItem,
  TitleTypography,
  InformationTypography,
  CheckIconContainer,
  TextContainer,
  SwitchButton,
  InsuranceSubItem,
  AddInsurance,
  AddInsuranceContainer,
  IconContainer,
  LoaderContainer,
  InsuranceSkeletonContainer,
  AddInsuranceTypography,
};
